export default __webpack_public_path__ + "static/media/intro_ml.f7e09289.svg";